import {
  AccountCircleOutlined,
  BadgeOutlined,
  BusinessOutlined,
  FormatListNumberedOutlined,
  GroupAdd,
  HomeOutlined,
  HowToReg,
  InfoOutlined,
  LanguageOutlined,
  LocalPhoneOutlined,
  LocationOnOutlined,
  PaymentOutlined,
  StoreOutlined,
  SupervisorAccount,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useVendorProfileDetailContext } from "contexts/VendorProfileDetailContext";

import { useAuth } from "hooks";
import React from "react";

const VendorProfileBasicDetail = () => {
  const { vendorProfileDetail, loadingVendorProfileDetail } =
    useVendorProfileDetailContext();
  const { isVendor } = useAuth();

  return !loadingVendorProfileDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item md={3}>
                <InformationTile
                  title="Vendor"
                  icon={() => <AccountCircleOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.vendor?.name}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Shop Name"
                  icon={() => <StoreOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.shopName}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Vendor Profile ID"
                  icon={() => <BadgeOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.vendorProfileId}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Province"
                  icon={() => <LocationOnOutlined color="primary" />}
                  subtitle={
                    (Array.isArray(vendorProfileDetail?.province)
                      ? vendorProfileDetail.province
                      : [vendorProfileDetail?.province]
                    )
                      .filter(Boolean)
                      .map((province) => province.name)
                      .join(", ")
                  }
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Branch"
                  icon={() => <BusinessOutlined color="primary" />}
                  subtitle={
                    (Array.isArray(vendorProfileDetail?.branch)
                      ? vendorProfileDetail.branch
                      : [vendorProfileDetail?.branch]
                    )
                      .filter(Boolean)
                      .map(
                        (branch) =>
                          `${branch.name}${branch.code ? ` - ${branch.code}` : ""}`
                      )
                      .join(", ")
                  }
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Phone"
                  icon={() => <LocalPhoneOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.phone}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Email"
                  icon={() => <LocalPhoneOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.email}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Website"
                  icon={() => <LanguageOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.website}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Owner Name"
                  icon={() => <AccountCircleOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.ownerName}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Address"
                  icon={() => <HomeOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.address}
                />
              </Grid>

              {vendorProfileDetail?.paymentTerms && (
                <Grid item md={3}>
                  <InformationTile
                    title="Payment Terms"
                    icon={() => <PaymentOutlined color="primary" />}
                    subtitle={vendorProfileDetail?.paymentTerms}
                  />
                </Grid>
              )}

              <Grid item md={3}>
                <InformationTile
                  title="Registration Number"
                  icon={() => <FormatListNumberedOutlined color="primary" />}
                  subtitle={vendorProfileDetail?.registrationNo}
                />
              </Grid>

              <Grid item md={3}>
                <InformationTile
                  title="Relationship Manager"
                  icon={() => <SupervisorAccount color="primary" />}
                  subtitle={vendorProfileDetail?.relationshipManager?.name}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Referred By"
                  icon={() => <GroupAdd color="primary" />}
                  subtitle={vendorProfileDetail?.referredBy?.name}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Onboarded By"
                  icon={() => <HowToReg color="primary" />}
                  subtitle={vendorProfileDetail?.onboardedBy?.name}
                />
              </Grid>
              <Grid item md={3}>
                <InformationTile
                  title="Added By"
                  icon={() => <HowToReg color="primary" />}
                  subtitle={vendorProfileDetail?.addedUser?.name}
                />
              </Grid>

              {!isVendor && (
                <Grid item md={3}>
                  <InformationTile
                    icon={() => <InfoOutlined color="primary" />}
                    title="Status"
                  >
                    <div
                      className={`uppercase ${vendorProfileDetail?.status === "Active"
                        ? "text-green-600"
                        : "text-red-600"
                        }`}
                    >
                      {vendorProfileDetail?.status === "Active"
                        ? "Active"
                        : "Inactive"}
                    </div>
                  </InformationTile>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default VendorProfileBasicDetail;
